import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux";
import "./styles/App.css";
import antdEnUS from "antd/es/locale/mn_MN";
import { ConfigProvider } from "antd";
import { CustomProvider } from "rsuite";
import deDe from "rsuite/locales/en_US";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ConfigProvider locale={antdEnUS}>
      <CustomProvider locale={deDe}>
        <App />
      </CustomProvider>
    </ConfigProvider>
  </Provider>
);
